import { render } from "./ReadingPractice.vue?vue&type=template&id=77e8eb00&ts=true"
import script from "./ReadingPractice.vue?vue&type=script&lang=ts"
export * from "./ReadingPractice.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__